module.exports = __webpack_public_path__ + "img/qwen-enhance-rainy-desk.d782b774.webp";